import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// constants
import { Forms } from 'constants/forms'
// icons
import PlusIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'
// themes
import { colors } from 'themes/index'
// types
import { IField } from 'types/graphql'
import { FilterField } from '../../index'
// views
import { FieldName, FiltersWrapper, RuleWrapper, UnavailableField, Value } from './views'
// utils
import { getFilterValue, hasFilterField } from 'components/Modals/RiskViewFilterModal/utils'

interface Props {
  data: FilterField[]
  fields: IField[]
  setField: (field: IField & { idx: number }) => void
  removeFilter: (idx: number) => void
  setIsConfigured: (value: boolean) => void
}

const Filters: React.FC<Props> = ({ data, fields, setField, removeFilter, setIsConfigured }) => {
  const dispatch = useDispatch()

  const onFilterClick = (filter: FilterField, idx: number) => {
    dispatch(change(Forms.RISK_VIEW_FILTER_FORM, filter.id, { action: filter.action, value: filter.value }))
    setField({ ...fields.find(({ id }) => id === filter.id), idx })
    setIsConfigured(true)
  }

  return (
    <FiltersWrapper>
      {data.map((filter, idx) => {
        const isUnavailable = !hasFilterField(filter, fields)

        return (
          <RuleWrapper key={filter.id} data-testid='risk-filter-rule' data-entity-id={filter.id}>
            {isUnavailable ? (
              <UnavailableField>Unavailable field</UnavailableField>
            ) : (
              <div>
                <FieldName onClick={() => onFilterClick(filter, idx)}>{filter.name}</FieldName>
                {` ${filter.action.replace('_', ' ').toLowerCase()} `}
                <Value>{getFilterValue(filter)}</Value>
              </div>
            )}

            <IconButton onClick={() => removeFilter(idx)} size='large'>
              <DeleteIcon fontSize='small' htmlColor={colors.blue500} />
            </IconButton>
          </RuleWrapper>
        )
      })}
      <IconButton data-testid='risk-filter-add-rule-button' onClick={() => setIsConfigured(true)} size='large'>
        <PlusIcon htmlColor={colors.purple500} />
      </IconButton>
    </FiltersWrapper>
  )
}

export default Filters
